var alignment_rtlignore_default = {
  "alignLeft": "nWf-o",
  "textWrapNowrap": "CbJsW",
  "alignRight": "dcVmx",
  "alignCenter": "_1Jy5C",
  "sizeFullWidth": "ab9XP",
  "renderedInTable": "dd6Z4",
  "sizeOriginal": "cH9p5",
  "sizeContent": "IkRp9",
  "sizeSmall": "iuyeC",
  "sizeSmallCenter": "_1p5pR",
  "flex": "m7nSM",
  "LEFT": "UBqBM",
  "CENTER": "m6O31",
  "RIGHT": "B3IzJ",
  "AUTO": "Aw9ca",
  "JUSTIFY": "SAtzW"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
